module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }), _c('div', {
    staticClass: "title-chapter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aaron’s rod:")]), _vm._v(" The rod, or wand, with a serpent twined round it, which was used in the Mosaic ceremony of initiation; it appears to have contained the sacred fire. Now commonly employed as an emblem signifying a physician; similar to the caduceus of Hermes.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Abbadon:")]), _vm._v(" The Hebrew name of the “bottomless pit,” the place of the lost in "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Sheol;")]), _vm._v(" the abyss of hell.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ABC of the Devil:")]), _vm._v(" Handwritten books for the use of magicians and sorcerers.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Abhasa:")]), _vm._v(" A Sanskrit term (literally meaning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("shining forth")]), _vm._v(") for the cosmopsychological process which takes place as the One becomes the Many, as it is described by the philosophical system called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Trika")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Abhasana:")]), _vm._v(" The same as "), _c('em', {
    staticClass: "i"
  }, [_vm._v("abhasa")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Abhava:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("non-being, non-existence.")]), _vm._v(" In Hindu philosophy, a means of correct knowledge defined as the deduction of the existence of one of two opposite things from the non-existence of the other.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Abheda:")]), _vm._v(" A Sanskrit term (literally meaning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("indistinct")]), _vm._v(") for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("identity,")]), _vm._v(" used especially in reference to any philosophy which denies the distinctness of spiritual and material, or divine and human principles.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Abhiseka:")]), _vm._v(" In Hinduism, the ceremonial bathing in sacred waters. In Buddhism, the tenth stage of perfection. The term is used also for the anointment of kings and high officials upon their ascension to power or as a recognition of some signal achievement.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Abidharma:")]), _vm._v(" The third part of the Buddhist Tripitaka (q.v.) containing lessons in metaphysics and occultism.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Abigor:")]), _vm._v(" In demonography, the name of a powerful demon, high-ranking in the infernal empire.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Abominable snowmen:")]), _vm._v(" A legendary race of superhuman giants, hostile to man, inhabiting the snowy slopes of the Himalayas.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Abracadabra:")]), _vm._v(" A magic word. A triangular arrangement of its letters worn on an amulet is believed by occultists to bring health and ward off disease.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Abraxas:")]), _vm._v(" A magic word, said to be the name of a god, the seven letters of which form the number 365, the number of days in a year. The word engraved on a gem or stone is considered by occultists to constitute a very potent charm.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Absent treatment:")]), _vm._v(" Cure of physical illness from a distance, by occult or metaphysical means.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Absolute:")]), _vm._v(" In metaphysics and mystic philosophy, the Absolute is the ultimate referent of thought, the Unconditioned, the opposite of the Relative.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Absolute Ego:")]), _vm._v(" In the philosophical system of J. G. Fichte (1762–1814), the Ego before its differentiation into an empirical Self and Non-Self.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Absolutism:")]), _vm._v(" The theory of the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Absolute")]), _vm._v(" (q.v.); the view that standards of moral value are objective, absolute, superhuman and eternal.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Abstract:")]), _vm._v(" A partial aspect or quality considered in isolation from an object as a whole.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acarya:")]), _vm._v(" A Sanskrit word, meaning “spiritual teacher”; a title given to high-ranking adepts of esoteric science.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Accepted chela:")]), _vm._v(" A disciple of esoteric philosophy, who has passed the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("fourth initiation.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acolyte:")]), _vm._v(" In occultism, “anyone under occult discipline at a stage of first responsibilities, but prior to formal induction into the invisible fellowship; a licentiate or probationer.” (Marc Edmund Jones)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acosmism:")]), _vm._v(" The doctrine that the external, physical world is non-existent, unreal, a mere appearance ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("maya")]), _vm._v(") of the Supreme Being, who is the only reality.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Active influence:")]), _vm._v(" A term used in astrology, to denote the influence resulting from an aspect between two or more astrological factors or sensitive points, thereby producing the action that can materialize in an event.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Activism:")]), _vm._v(" The philosophical theory which considers activity, particularly spiritual activity, to be the essence of reality. The concept of pure act ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("actus purus")]), _vm._v(") traceable to Aristotle’s conception of divinity, was influential in Scholastic thought, and persists in Leibniz, Fichte and modern idealism.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adam Kadmon:")]), _vm._v(" Hebrew for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("primeval man.")]), _vm._v(" The Kabalistic name representing humanity, the “Heavenly Man,” prior to falling into sin.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adamic:")]), _vm._v(" An alternative name for the Polarian "), _c('em', {
    staticClass: "i"
  }, [_vm._v("root race")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adamic era:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cosmic epochs.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adapa:")]), _vm._v(" In Babylonian mythology, the name of a hero created and endowed with wisdom by Ea, whose temple at Eridu he was to tend. Summoned before Anu, god of the sky, he unwittingly refused immortality.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Additor:")]), _vm._v(" A modified ouija board; a small round, hollow box, with a pointer protruding from it, moves under the fingers over the board bearing the letters of the alphabet.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adept:")]), _vm._v(" One who has attained to proficiency in any art or science. In occultism, one who has attained the stage of initiation and has become a Master of esoteric science and philosophy.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adhyatma:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Supreme Spirit.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adience:")]), _vm._v(" That continuous, automatic repetition of action which esoteric philosophy regards as a characteristic of an "), _c('em', {
    staticClass: "i"
  }, [_vm._v("elemental")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aditi:")]), _vm._v(" The name (Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("boundlessness")]), _vm._v(") of a Vedic goddess, mother of the gods known as "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Adityas;")]), _vm._v(" she is identified at times with the earth, at times with the sky, and at other times is hailed as a cow.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adityas:")]), _vm._v(" A group of Vedic gods, sons of the goddess "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Aditi.")]), _vm._v(" Their number is variously given as six or eight, in later times also as twelve.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Admadiya:")]), _vm._v(" A Moslem sect founded in the late 19th century in India, which interprets the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("jihad")]), _vm._v(" (q.v.) as a striving after righteousness.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adonai:")]), _vm._v(" Hebrew word, meaning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("The Lord,")]), _vm._v(" used by Jews in speech and in writing instead of the name Jehovah, the mystic name of the God of Israel, which must not be pronounced.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adoption:")]), _vm._v(" The acquisition of a status or position.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adoptive masonry:")]), _vm._v(" Comasonry (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adramelech:")]), _vm._v(" In demonography, the president of the Supreme Council of the infernal empire.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Advaita:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("non-dualism.")]), _vm._v(" The Vedantic doctrine of monism advocated by Samkara, which contends that only the Ultimate Principle "), _c('em', {
    staticClass: "i"
  }, [_vm._v("(Brahman)")]), _vm._v(" has any actual existence, and that all phenomenal existence is an illusion ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("maya")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Advanced soul:")]), _vm._v(" In occult philosophy, a human being whose spiritual development has exceeded that attainable by his fellowmen.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adventists:")]), _vm._v(" Religious sects originating from the Advent Movement, professing the personal and premillennial second advent of Christ, and the renewal of the Earth as an abode for the redeemed after a physical resurrection of the dead.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aegir:")]), _vm._v(" The sea god of Norse mythology.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aeromancy:")]), _vm._v(" Divination by observing atmospheric conditions or ripples on the surface of the water.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aesculapius:")]), _vm._v(" The Roman god of healing and medicine.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aesir:")]), _vm._v(" In Norse mythology, the entourage of Odin.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aesma:")]), _vm._v(" The evil spirit of wrath, inspirer of vengeance and evil, in Zoroastrian demonology.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aeviternity:")]), _vm._v(" Eternity regarded as a whole, distinct from the flux of time—an endless temporal medium in which events and objects are fixed relative to each other.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Afreet:")]), _vm._v(" A class of jinns (q.v.) in Arabic mythology. (Also referred to as "), _c('em', {
    staticClass: "i"
  }, [_vm._v("afrit, afrite")]), _vm._v(" or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("efreet")]), _vm._v(")"), _c('em', {
    staticClass: "i"
  }, [_vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Agamas:")]), _vm._v(" The canon of scriptures of Jainism.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Agathodemon:")]), _vm._v(" Greek for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("good demon.")]), _vm._v(" A beneficent nature spirit or minor deity.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ages of mankind:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Root race.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Agla:")]), _vm._v(" The combination of the first letters of four Hebrew words meaning “Thou art forever mighty, O Lord.” Used as a magic word to exorcise demons and evil spirits.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Agni:")]), _vm._v(" The Vedic god of fire.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Agnosticism:")]), _vm._v(" The belief that certain knowledge has not been attained, either in some particular field (usually the religious) or in any and all fields of supposed knowledge.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Agricultural astrology:")]), _vm._v(" An application of astrology to the planting and the harvesting of crops.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aham brahma asmi:")]), _vm._v(" Sanskrit for “I am "), _c('em', {
    staticClass: "i"
  }, [_vm._v("brahman")]), _vm._v(",” the formula of the Upanishad, denoting the full coincidence of the human and divine, arrived at not so much by a spontaneous mystic insight as by logical deduction from the nature of world and self.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ahamkara:")]), _vm._v(" A Sanskrit term (literally meaning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("I-maker")]), _vm._v(") used to designate the principle which generates man’s consciousness of his own ego or personal identity.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ahanta:")]), _vm._v(" A Sanskrit term (literally meaning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("I-hood")]), _vm._v(" or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("selfness")]), _vm._v(") for the state of being an Ego.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ahimsa:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("non-injuring, not killing.")]), _vm._v(" The Hindu doctrine of the oneness and sacredness of all life, human and animal.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ain Soph:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("En-Soph.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ahriman:")]), _vm._v(" In Zoroastrian mythology, the personified principle of evil, leader of the Devas, powers of evil, in eternal conflict with Ahura Mazda. (Also called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Angra Mainyu.")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ahura:")]), _vm._v(" In Zoroastrian terminology, a beneficent deity.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ahura Mazda:")]), _vm._v(" Literally "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Lord of Knowledge.")]), _vm._v(" The chief benevolent deity of Zoroastrianism, personification of the Good, leader of the powers of light.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Akasha:")]), _vm._v(" In occultism, a celestial ether, or astral light that fills all space. According to occult teaching, every thought and action which takes place in the material world, is recorded in this akashic medium, whereby one possessed of psychic vision can read and translate the panorama of history, the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Akashic Records.")]), _vm._v(" They also hint that some day science will be able to tap this record and thus draw upon and even re-enact the words and actions of past ages. (Also spelled "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Akasa")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Akashic:")]), _vm._v(" Of or pertaining to the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("akasha")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Akashic Records:")]), _vm._v(" Scenic representations of every action, sentiment and thought since the beginning of the world. (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Akasha.)")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aksara:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("imperishable;")]), _vm._v(" a descriptive synonym for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("brahman")]), _vm._v(" (q.v.), the Absolute, in the Upanishads; it has also the meaning of “syllable.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Alam:")]), _vm._v(" Arabic for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("world.")]), _vm._v(" In Sufi terminology, the seven cosmic planes called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("alam")]), _vm._v(" are: 1) the lowest one, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("alam i sugrah,")]), _vm._v(" the world of human experience; 2) "), _c('em', {
    staticClass: "i"
  }, [_vm._v("alam i nasut,")]), _vm._v(" the material world of forms and bodies; 3) "), _c('em', {
    staticClass: "i"
  }, [_vm._v("alam i mithal,")]), _vm._v(" the astral world; 4) "), _c('em', {
    staticClass: "i"
  }, [_vm._v("alam i malakut,")]), _vm._v(" the spiritual world; 5) "), _c('em', {
    staticClass: "i"
  }, [_vm._v("alam i kabrut,")]), _vm._v(" the radiant plane of divine splendor; 6) "), _c('em', {
    staticClass: "i"
  }, [_vm._v("alam i lahut,")]), _vm._v(" the exalted divine plane of the first emanation; 7) the highest, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("alam i hahut,")]), _vm._v(" plane of absolute inactual being.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Alastor:")]), _vm._v(" In demonography, the name of a cruel, evil demon.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Alaya:")]), _vm._v(" The World Soul (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Alcahest:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Alkahest.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Alchemist:")]), _vm._v(" A practitioner of alchemy (q.v.) in any or all of its aspects.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Alchemy:")]), _vm._v(" The science of decomposing and recomposing things, as well as of changing their essential nature and raising it higher—transmuting them into each other. While chemistry deals with lifeless matter, alchemy employs life as a factor, and deals with higher forces of nature and the conditions of matter under which they operate. In its lowest aspect, it deals with physical substances, but in its highest aspect it teaches the regeneration of the spiritual man, the purification of mind, will and thought, and the ennobling of all the faculties of the human soul.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Alecto:")]), _vm._v(" In Roman mythology, one of the Furies (q.v.), genius of pestilence, war and vengeance.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Alectorius:")]), _vm._v(" In occultism, a small stone said to be found in the innards of cocks, and to have the effects of a powerful magical charm.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aleph:")]), _vm._v(" The first letter of the Hebrew alphabet. The most sacred of the Hebrew letters; seldom pronounced because indicative of the Deity.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Alfheim:")]), _vm._v(" The dwelling place of the elves of Norse mythology.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Alkahest:")]), _vm._v(" The universal solvent sought by alchemists. Materially, a substance capable of dissolving all other material substance, reducing it to the original matter of which it was formed. Symbolically, a force capable of affecting the astral forms of all things and of dissolving them by changing the polarity of their molecules.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("All Hallow’s Eve:")]), _vm._v(" An ancient Druidic festival when all fires had to be extinguished, except for the sacred altar fires of the Druid priests.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Allegorical interpretation:")]), _vm._v(" The interpretation of a book, a saying, a ritual, etc., discovering a hidden, symbolic, spiritual, occult or metaphorical meaning in it.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Allegory:")]), _vm._v(" Description in symbolical terms, or representation in symbolical form, with the true meaning hidden beneath the literal or obvious significance.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Allmuseri:")]), _vm._v(" An African occult society.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Alocer:")]), _vm._v(" In demonography, the name of a mighty demon.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Alphitomancy:")]), _vm._v(" An ancient form of divination of the guilt or innocence of an accused individual by making him swallow a piece of a barley loaf, which was supposed to produce indigestion in the guilty.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Alpiel:")]), _vm._v(" In Hebrew mysticism, a demon who rules over fruit-trees.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Alraune:")]), _vm._v(" In Teutonic mythology, a female demon. Also the name of small statuettes made of ash root and supposed to have magic powers.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Altar:")]), _vm._v(" Any place set aside for communicating with a god, with supernatural entities, or with the dead, by means of sacrifices or offerings.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Amaimon:")]), _vm._v(" In magic lore, the spirit ruling the Eastern portion of the universe.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Amazons:")]), _vm._v(" A mythical race of warrior women who lived in a matriarchal society and put their male children to death, raising only the girls to become warriors.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ambrosia:")]), _vm._v(" The food of the gods of Greek mythology.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Amen:")]), _vm._v(" A Hebrew word, used nowadays in the meaning “verily,” but considered by occultists to have originally been a mystic word, related to the Sanskrit "), _c('em', {
    staticClass: "i"
  }, [_vm._v("om.")]), _vm._v(" In theosophical and related esoteric parlance, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("amen")]), _vm._v(" means “the concealed.”")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ameretat:")]), _vm._v(" In Zoroastrianism, one of the Amesha Spentas (q.v.), the personified representation of immortality, spirit of trees and plants.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Amesha Spenta:")]), _vm._v(" One of the six immortal holy ones, high deities of Zoroastrianism, attendants of Ahura Mazda. They represent the personified attributes of Ahura Mazda: Ameretat (immortality), Aramaiti (holy harmony), Asha (righteousness), Haurvatat (saving health), Kshathra (rulership), and Vohumanah (good thought). They are known also as the Amshaspands.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Amica:")]), _vm._v(" The Aquarian Mystical Institute of Color Awareness. (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("color awareness.")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Amon:")]), _vm._v(" In demonography, the name of one of the strongest of all demons.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Amon; Ammon:")]), _vm._v(" Originally a local god of Thebes in ancient Egypt, later identified with Amon-Ra (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Amon-Ra:")]), _vm._v(" The Egyptian king of the gods, creator of the universe; originally the god of Thebes, later supreme god of all Egypt.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A.M.O.R.C.:")]), _vm._v(" The abbreviation of the full, official name of the Rosicrucian Order (q.v.), i.e.: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ancient Mystical Order Rosae Crucis.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Amor Dei intellectualis:")]), _vm._v(" Latin for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("intellectual love of God.")]), _vm._v(" A term introduced by Spinoza, which he uses to denote an enduring, impersonal love.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Amrita:")]), _vm._v(" The drink or food of the gods of the Vedic myths. Identified with the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("soma")]), _vm._v(" drink (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Amshaspands:")]), _vm._v(" The six Amesha Spentas of Zoroastrianism.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Amulet:")]), _vm._v(" A material object on which a charm is written or over which a charm was said, worn on the person to protect the wearer against dangers, disease, to serve as a shield against demons, ghosts, evil magic, and to bring luck and good fortune.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Amy:")]), _vm._v(" In demonography, the name of a mighty demon, one of the ruling hierarchy of the infernal empire.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("An:")]), _vm._v(" The Sumerian god of heaven.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Analogy:")]), _vm._v(" A similitude in relationship.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anamelech:")]), _vm._v(" In demonography, the name of a demon, harbinger of bad tidings.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anamnesis:")]), _vm._v(" Greek for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("recollection.")]), _vm._v(" Plato used this term for the memory which human consciousness has of facts and events in an earlier incarnation.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ananda:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("joy, happiness, bliss.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ananisapta:")]), _vm._v(" In occultism, a word of magical effects; when written on parchment and worn on the body, it is believed to be a protection against disease.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ananya bhakti:")]), _vm._v(" In "), _c('em', {
    staticClass: "i"
  }, [_vm._v("bhakti yoga")]), _vm._v(" (q.v.) the cult of the transcendent but objective monotheistic God.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anastikaya:")]), _vm._v(" A Sanskrit term meaning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("not body-like, unextended.")]), _vm._v(" (Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("astikaya")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ancestor worship:")]), _vm._v(" A religious system based on the belief that the spirits of the dead linger about their earthly habitations, have powers of protecting and blessing those responsible for their care, and of avenging their neglect. The doctrine and practice is observed and followed in various parts of the world, notably in China and Japan.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anchoret; anchorite:")]), _vm._v(" Greek for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("recluse.")]), _vm._v(" The term applied to an extreme type of Christian ascetics who sought spiritual perfection by withdrawing from the community, often exposing themselves to hardships.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ancient Mystical Order Rosae Crucis:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Rosicrucian Order.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ancilia:")]), _vm._v(" The twelve sacred shields of ancient Rome, on the safety of which the fate of the Roman people was believed to depend. The first Ancile was said to have dropped to earth from heaven.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Android:")]), _vm._v(" A human being produced by means other than natural conception and birth.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Angakok:")]), _vm._v(" An Eskimo shamanistic medium and witch-doctor.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Angel:")]), _vm._v(" A living creature of the spirit world, intermediate between gods and humans, and either friendly or hostile toward humanity. Angels belong to the class properly known as "), _c('em', {
    staticClass: "i"
  }, [_vm._v("demons.")]), _vm._v(" In the monotheistic religions, the word "), _c('em', {
    staticClass: "i"
  }, [_vm._v("angel")]), _vm._v(" is usually applied to the benevolent agents and messengers of God.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Angelified flesh:")]), _vm._v(" The heavenly substance of which the bodies of angels are formed, according to Christian mystics.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Angelology:")]), _vm._v(" The study and classification of angels and their characteristics.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Angra Mainyu:")]), _vm._v(" An alternative name of Ahura Mazda (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anima mundi:")]), _vm._v(" Latin for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("soul of the world.")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("World Soul.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Animal magnetism:")]), _vm._v(" According to all schools of mysticism, occultism and esoteric philosophy, a force which causes a fluid emanation to issue forth from all men, animals and even inanimate objects as an "), _c('em', {
    staticClass: "i"
  }, [_vm._v("aura")]), _vm._v(" (q.v.) or as a form of light; some persons can emit it, for purposes of magic healing, from their eyes or the tips of their fingers.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Animal soul:")]), _vm._v(" In occult terminology, the personalized desire in man.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Animatism:")]), _vm._v(" The belief that all or certain important objects possess life or communicable energy. The belief in an impersonal supernatural power.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Animism:")]), _vm._v(" The belief in spirits of nature. The belief that persons and objects are animated by spirits. Also, the belief that all or most of animate beings as well as all or most of inanimate nature possess reason and will equal to those of man and have human-like mental processes.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ankh:")]), _vm._v(" The Egyptian cross, shaped like a capital T with an oval loop on the top, symbol of life in occult tradition.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Annakaya:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("physical body.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anointing tablet:")]), _vm._v(" In ancient Egyptian occult practices, a device entombed with the bodies or mummies of the deceased; an alabaster tablet containing seven hollows for the seven holy oils intended for magical protection on the journey to the next world.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anpiel:")]), _vm._v(" In Hebrew mysticism, the angel ruling the birds.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Antahkarana:")]), _vm._v(" A Sanskrit term, literally meaning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("internal sense organ.")]), _vm._v(" In occult philosophy, the term is used to indicate the bridge between the higher and the lower aspect of the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("manas.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Antediluvian:")]), _vm._v(" Before the Deluge.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anthropomancy:")]), _vm._v(" The ancient art of divination by examining the intestines of a dead person—specifically, of a human sacrifice.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anthropomorphic:")]), _vm._v(" Of human shape; conceived of as shaped like human beings.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anthropomorphism:")]), _vm._v(" The ascription of human traits or characteristics to non-human entities, or representing them in human form.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anthropopathism:")]), _vm._v(" The ascription of human feelings to non-human beings or objects.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anthroposcopy:")]), _vm._v(" The deduction of a person’s character, characteristics, abilities, etc. from his face.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anthroposophy:")]), _vm._v(" An occult and mystic philosophical movement, based on the teachings of its founder, Rudolf Steiner, aiming at man’s progressive liberation from the chains of egoism and at the development of his dormant faculties and higher capacities for knowledge and enlightenment, to enable him to perceive and respond to “subtler manifestations of Nature.” Anthroposophists place great emphasis, among other things, on the occult significance of colors and their relations to human emotions (cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("color awareness")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Antichrist:")]), _vm._v(" The enemy of mankind who will establish a reign of evil in the world, as a punishment for man’s wickedness. His reign, replete with wars, evil doings and miracles of black magic, will last for fifty years, but he will be overthrown by Christ at His second coming.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Antipathy:")]), _vm._v(" In astrology, a term denoting disharmony of two bodies, usually planets, which rule or are exalted in opposite Signs. (For example, Saturn ruling Capricorn, has an antipathy for the Moon, ruling Cancer.)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anu; Anum:")]), _vm._v(" The Babylonian and Assyrian god of heaven, ruler of destiny, king of gods, chief of the Babylonian triad of gods (the other two were Ea and Enlil).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anubis:")]), _vm._v(" The jackal-headed god of ancient Egypt, son of Osiris; he presides over the embalming of the dead, leads them to the hall of judgment and supervises the weighing of their hearts.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anugita:")]), _vm._v(" An occult treatise, one of the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Upanishads.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anugraham:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("grace.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anwyl:")]), _vm._v(" The world of the dead in Celtic mythology.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apantomancy:")]), _vm._v(" Divination by means of any object that happens to meet the eye.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apeiron:")]), _vm._v(" Greek for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("infinite, indeterminate.")]), _vm._v(" The Greek philosopher Anaximander (6th century B.C.) used the term for the primal indeterminate matter out of which all things come to be.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apheta:")]), _vm._v(" In astrology, the planet or place that exercises an influence over the life and death of the native (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aphrodite:")]), _vm._v(" Greek goddess of love and beauty.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apis:")]), _vm._v(" The bull-headed god of ancient Egypt, regarded as an incarnation of Osiris. Also, a black bull with distinctive markings, whose worship was linked with various deities.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apocatastasis:")]), _vm._v(" Greek for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("re-establishment.")]), _vm._v(" In Stoic philosophy, the belief that all things will return to their original condition after a cycle of ages.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apollo:")]), _vm._v(" The Roman god, son of Jupiter, known by many names, principally as Sol (the sun).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apotropaism:")]), _vm._v(" Protective or defensive magic, i.e., the use of magic rituals, incantations or other esoteric formulae in order to ward off or to overcome evil influences.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apparition:")]), _vm._v(" A supernormal appearance; especially in spiritualistic and mediumistic practices.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apport:")]), _vm._v(" The arrival of an object through solid matter; also, the object so appearing.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Appulse:")]), _vm._v(" In astrology, the near approach of one orbital body to another—a conjunction; the culmination at or crossing of the meridian. (Applied particularly to the appulse of the Moon to the Earth’s shadow.)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aquarian Epoch:")]), _vm._v(" The era of the world which, according to occult teachings, began in March 1948, when the sun entered the constellation of Aquarius and the previous era, called the Piscean Epoch, ended. The Aquarian Epoch is to last 2,000 years. Many esoteric societies and organizations have therefore names containing the word Aquarian, e.g., the Aquarian Order, the Aquarian Mission, the Aquarian Mystical Institute of Color Awareness, etc.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aquarius")]), _vm._v(" (The Water Bearer): The eleventh sign of the zodiac. Its symbol ("), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9780806537009_i0003.jpg",
      "src": "Book1/e9780806537009_i0003.jpg"
    }
  })]), _vm._v(") represents a stream of water, symbolizing the servant of humanity who pours out the water of knowledge to quench the thirst of the world. The Sun is in Aquarius annually from January 21 to February 20. Astrologically it is the second thirty-degree arc following the Sun’s passing of the Winter Solstice, occupying a position along the Ecliptic from 300° to 330°. It is the “fixed” quality of the element Air, in which the will is largely motivated by reasoning processes—whether sound or unsound. It is positive, hot, moist, sanguine, rational and obeying. Ruler: Saturn; or by some moderns: Uranus. Exaltation: Mercury. Detriment: Sun. Symbolic interpretation: Waves, or water, or the vibrationary waves of electricity; parallel lines of force.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aquastor:")]), _vm._v(" In occultism, a being created by the power of imagination and concentration of thought.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aralu:")]), _vm._v(" The underworld, abode of the dead in Babylonian mythology. Conceived of as a vast, dark underground cave, entered through a hole in the earth, guarded by seven doors, to which all human beings go after death, never to return, but able to communicate with and give oracles to the living.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aramaiti:")]), _vm._v(" One of the six Amesha Spentas (q.v.) of Zoroastrianism, the personified representation of holy harmony, spirit of the earth.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Arambha-vada:")]), _vm._v(" The theory of evolution taught by the Indian philosophical systems Nyaya and Vaisesika, stating that atoms combine upon being created to form the world in its entirety.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aranyakas:")]), _vm._v(" The “Forest Books” of Hinduism, so called because they were used in teachings in the secrecy of the forest; they are mystical, esoteric meditations on the meaning of ritual lore.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Arariel:")]), _vm._v(" In Hebrew mysticism, the angel who presides over the waters.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Arathron:")]), _vm._v(" The Olympian Spirit (q.v.) governing Saturn, ruler of 49 Olympian Provinces of the universe; his day is Saturday.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Arbatel:")]), _vm._v(" A book of magic rituals, published in the late sixteenth century.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Arcane:")]), _vm._v(" A synonym for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("esoteric")]), _vm._v(" or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("occult.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Arcanum:")]), _vm._v(" An elixir used as a stimulant for divination. (Plural: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("arcana.")]), _vm._v(" Cf. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("tarot")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Arcanum arcanorum:")]), _vm._v(" Medieval Latin term for the “secret of secrets”; the ultimate secret.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Archaes:")]), _vm._v(" A synonym for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("astral light")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Archer:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Sagittarius.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Archetypal world:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Yesod.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Archetype:")]), _vm._v(" The original pattern, of which actual things are copies or reproductions. A collective, generalized representative of an idea or group of ideas or characteristics.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Architect:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Sovereign Grand Architect of the Universe.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Archons:")]), _vm._v(" In occultism, primordial planetary spirits. In Manicheism, the Sons of Dark, who swallowed up the bright elements of the Primal Man.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Arda Viraf Nameh:")]), _vm._v(" A sacred book of Zoroastrianism, dealing with cosmogony, cosmology and eschatology.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ares:")]), _vm._v(" The ancient Greek god of war and pestilence. The Romans identified him with Mars.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ariel:")]), _vm._v(" The poetic name of Jerusalem used by Hebrew mystics.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aries")]), _vm._v(" (The Ram): The first sign of the zodiac. Its symbol ("), _c('span', {
    staticClass: "imageinline"
  }, [_c('img', {
    attrs: {
      "alt": "e9780806537009_i0004.jpg",
      "src": "Book1/e9780806537009_i0004.jpg"
    }
  })]), _vm._v(") represents the head and horns of the ram. In astrology, it is a symbol of offensive power—a weapon of the gods, hence an implement of the will. The Babylonians sacrificed rams during the period when the Sun occupied this sign, which occurs annually from March 21 to April 20. Astrologically and astronomically it is the first thirty-degree arc beginning at the point of the Spring Equinox. It is the “leading” quality of the element Fire: positive, diurnal, movable, dry, hot, fiery, choleric and violent. Ruler: Mars. Exaltation: Sun. Detriment: Venus. Fall: Saturn. Symbolic interpretation: Sprouting seed; fire in eruption; a fountain of water; a ram’s horns.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aries era:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cosmic epochs.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Arioch:")]), _vm._v(" In demonology, the name of a demon of vengeance.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ariolist:")]), _vm._v(" A practitioner of the ancient art of divination by altars, called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("ariolatio.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Arithmancy:")]), _vm._v(" Fortune-telling by numbers, especially by the number of letters in names. (Also called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("arithmomancy.")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Artificial omen:")]), _vm._v(" A sign of future events which will or may happen as an act of human doing or will.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aruspicy:")]), _vm._v(" An ancient method of divination by examining the entrails of human or animal sacrifices. (Also called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("haruspicy")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aryasatyani:")]), _vm._v(" The "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Four Noble Truths")]), _vm._v(" (q.v.) taught by Gautama Buddha.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aryan:")]), _vm._v(" The fifth "), _c('em', {
    staticClass: "i"
  }, [_vm._v("root race")]), _vm._v(" (q.v.) in esoteric philosophy.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Asana:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("sitting, posture;")]), _vm._v(" one of the stages of the practice of Yoga.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ascendant:")]), _vm._v(" In astrology, the degree of the Zodiac (q.v.) which appeared on the eastern horizon at the moment for which a Figure (q.v.) is to be cast.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ascending arc:")]), _vm._v(" In theosophical occultism, the ascent of the evolving "), _c('em', {
    staticClass: "i"
  }, [_vm._v("monads")]), _vm._v(" (q.v.) from the physical plane or globe upwards through the higher levels of existence. (Also called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("luminous arc")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ascension:")]), _vm._v(" In astrology, the vertical rising of a planet above the ecliptic, equator or horizon. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Right Ascension")]), _vm._v(" is the circle of declination reckoned toward the east from 0° Aries, measured in the plane of the Equator. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Oblique Ascension")]), _vm._v(" is measured on the Prime Vertical.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Asceticism:")]), _vm._v(" The view that the physical body is an evil and a detriment to a righteous moral and spiritual life, and that through moderation or renunciation of the things generally considered pleasant, one can reach a higher spiritual state or degree of enlightenment. Also, the practice of this belief.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aseka:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("adept")]), _vm._v(" (q.v.)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Asgard:")]), _vm._v(" In Norse mythology, Odin’s headquarters, home of the gods, also housing the Valhalla, hall of the chosen among those slain in battle.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Asha:")]), _vm._v(" In Zoroastrianism, one of the six Amesha Spentas (q.v.), personified representation of righteousness, spirit of fire.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ashram:")]), _vm._v(" The Hindu name of a settlement of disciples living with or around a "), _c('em', {
    staticClass: "i"
  }, [_vm._v("guru")]), _vm._v(" (spiritual leader or teacher).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ashtart:")]), _vm._v(" The fertility goddess of the Semitic races; ever-virginal, yet the fruitful mother and creator of life. Also known as Astarte, in Babylonia as Ishtar, and in Canaan as Ashtoreth.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ashtavadhaza:")]), _vm._v(" In Hindu mysticism, the ability to grasp or attend to different matters at the same time.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ashur:")]), _vm._v(" A national war god of ancient Assyria, represented shooting the bow inside of a winged disk.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Asmita:")]), _vm._v(" A Sanskrit term meaning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("“I-am-ness.”")]), _vm._v(" The view which presumes lower states of mind to be the Self ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("purusha")]), _vm._v(")"), _c('em', {
    staticClass: "i"
  }, [_vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Asmodeus:")]), _vm._v(" In demonography, a destructive demon, at times identified with the serpent of the Garden of Eden, also with Samael (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Asomatic:")]), _vm._v(" A Greek term, meaning "), _c('em', {
    staticClass: "i"
  }, [_vm._v("disembodied")]), _vm._v(" (separated from the body).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aspect:")]), _vm._v(" In occultism and esotericism, the form under which any natural or mystic principle manifests itself.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aspect:")]), _vm._v(" In astrology, certain angular relationships between the rays which reach the Earth from two celestial bodies, or between one ray and a given point; the degree that was on the horizon at a given moment, or that represents the position of a planet at a given moment; the point on which an Eclipse or other celestial phenomenon occurred; the places of the Moon’s Nodes; or the cusps of the Houses, particularly the First and Tenth. Generally speaking, the term "), _c('em', {
    staticClass: "i"
  }, [_vm._v("aspect")]), _vm._v(" is applicable in astrology to any blending of rays that results in their interactivity. The body which has the faster mean motion is said to aspect the slower one.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aspectarian:")]), _vm._v(" A chronological list of all astrological aspects (q.v.) formed during a specified period.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aspirant:")]), _vm._v(" A disciple of esoteric philosophy, eligible for initiation.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Asport:")]), _vm._v(" The disappearance of a solid object through solid walls or other solid matter; the opposite of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("apport")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astaroth:")]), _vm._v(" In demonography, a powerful demon, high-ranking in the infernal empire.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astika:")]), _vm._v(" A Sanskrit term, denoting an individual who acknowledges the authority of the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Veda")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astikaya:")]), _vm._v(" A Sanskrit term for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("bodily")]), _vm._v(" or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("extended substance.")]), _vm._v(" In Jaina philosophy, only time is unlike a body ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("anastikaya")]), _vm._v("), hence unextended.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astragalomancy:")]), _vm._v(" Foretelling the future by means of dice marked with letters of the alphabet.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astral body:")]), _vm._v(" In occultism, man’s ethereal counterpart, a replica of the physical body (the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("gross body")]), _vm._v("), but of a more subtle and tenuous substance, penetrating every nerve, fibre and cell of the physical organism, and constantly in a supersensitive state of vibration and pulsation. It may depart from the gross body for short whiles, but cannot sever its connection with the latter without causing it to die. The more active is the gross body, and the more conscious it is of its physical environment, the more inactive is the astral body. The astral body is most active when the gross body sleeps, and this is when the astral body may communicate with astral bodies of other living persons or of the dead.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astral light:")]), _vm._v(" In occult terminology, the name of a universal living element which is described as an element and a power at the same time and containing the character of all things. It is said to be the storehouse of memory for the Macrocosm, the contents of which may be reimbodied and reincarnated—and at the same time the storehouse of the memory of man’s Microcosm, into which he delves to recollect past happenings. While it exists uniformly all throughout the universe its density and activity are increased around certain objects, in particular around the human brain and spinal cord; it is the medium through which thought is transmitted, and its presence around man’s nerve cells and conduits enables human beings to perceive impressions on the astral aura and thus to “read by the astral light”—the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("akashic reading,")]), _vm._v(" scientifically called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("clairvoyance.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astral plane:")]), _vm._v(" In those occult doctrines which believe in various planes of existences beyond the material one (e.g., in Theosophy), the first plane of existence after the death of the physical body. In doctrines which recognize only one plane of existence beyond the material one (e.g., in Rosicrucianism), this term is interpreted as a name for the sphere of non-material existence.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astral projection:")]), _vm._v(" In occult terminology, the partial or complete separation of the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("astral body")]), _vm._v(" (q.v.) from the physical body, and visiting another locality, near or far. This occurs in sleep—though, as a general rule, one does not recall the experience on waking. The adept can command his astral body to go any place he desires in order to make observations and investigations, and acquire essential information.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astral shell:")]), _vm._v(" The personality in its aspect of disintegration after the death of the physical body.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astral soul:")]), _vm._v(" In theosophical terminology, a synonym for the lower "), _c('em', {
    staticClass: "i"
  }, [_vm._v("manas,")]), _vm._v(" the reflection of the higher Ego, and not synonymous with "), _c('em', {
    staticClass: "i"
  }, [_vm._v("astral body.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astral sphere:")]), _vm._v(" The astral world (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astral world:")]), _vm._v(" The first sphere of existence after the death of the body.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astrological symbols:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Symbols, astrological.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astrology:")]), _vm._v(" The belief in and study of the influence upon human character of cosmic forces emanating from celestial bodies. There are two fundamentally different methods, or approaches, to astrology: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("geocentric astrology")]), _vm._v(" is based upon calculations of the planetary positions as seen by the observer on the Earth, i.e., using the Earth as a center; "), _c('em', {
    staticClass: "i"
  }, [_vm._v("heliocentric astrology")]), _vm._v(" bases its interpretations upon positions within the solar system with reference to the Sun as the center. As to purpose and application, there are several distinct branches of astrology, such as "), _c('em', {
    staticClass: "i"
  }, [_vm._v("agricultural, electional, horary, mundane, natal astrology, astrometeorology")]), _vm._v(" (q.v.), etc.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astromancy:")]), _vm._v(" A system of divination by means of the stars. (Not synonymous with "), _c('em', {
    staticClass: "i"
  }, [_vm._v("astrology.")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astrometeorology:")]), _vm._v(" Investigation of the relation between the Solar system bodies and the weather; the application of the art to the forecasting of weather conditions, earthquakes and severe storms; also known as "), _c('em', {
    staticClass: "i"
  }, [_vm._v("meteorological astrology.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astronomos:")]), _vm._v(" The title given by the priests to the Initiate in the seventh degree of the reception of the mysteries in the Initiation at Thebes in Egypt.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astrotheology:")]), _vm._v(" A system of theology founded on what is known of the heavenly bodies, and of the laws which regulate their movements.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Asura:")]), _vm._v(" In Hindu mysticism, a fallen angel or demon, hostile to the gods ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("devas")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aswattha:")]), _vm._v(" The Sanskrit name of the Tree of Knowledge, conceived of as the tree of cosmic life and existence; its roots, extending upward, symbolize the invisible spiritual world, and its branches, spreading downward, symbolize the visible, tangible, material universe.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ate:")]), _vm._v(" In Roman mythology, daughter of Jupiter, goddess of revenge and all evil, inciter of mankind to evil thoughts and deeds.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Atharva Veda:")]), _vm._v(" The latest of the four "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Vedas")]), _vm._v(" (q.v.), containing many magic charms and incantations, as well as hymns and prayers similar to those in the Rig Veda. (It is often referred to as the “Veda of Occult Powers.”)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Atlantean:")]), _vm._v(" The fourth "), _c('em', {
    staticClass: "i"
  }, [_vm._v("root race")]), _vm._v(" (q.v.) in esoteric philosophy.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Atlantis:")]), _vm._v(" The “lost continent” of the fourth "), _c('em', {
    staticClass: "i"
  }, [_vm._v("root race")]), _vm._v(" according to esoteric philosophy, said to have lain between Africa and South America.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Atma; atman:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Spirit.")]), _vm._v(" In occultism, the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Universal Spirit")]), _vm._v(" or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("World Soul.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Atmaswarupa:")]), _vm._v(" The Sanskrit term used by Hindu mystic philosophers for the universe. (Literally: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("manifestation of the Spirit")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aton:")]), _vm._v(" The name (also given as "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Aten")]), _vm._v(") of the Egyptian god personifying the disk of the sun, as the deity of the monotheistic religion which Amenhotep IV, renamed Ikhnaton (or Akhenaten) attempted to introduce in Egypt in the 14th century B.C. This religion did not survive its royal founder and sponsor.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Atonement:")]), _vm._v(" A religious act of expressing consciousness of one’s sins, as well as penitence and reconciliation.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("At-one-ment:")]), _vm._v(" A term used in Christian science for the spiritual union with the Immortal Mind.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Atziluth:")]), _vm._v(" In Kabbalistic cosmogony, the archetypal world.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Audition:")]), _vm._v(" The hearing of voices without the agency of physical auditory senses or organs; the auditory counterpart of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("vision")]), _vm._v(" (q.v.), often accompanying the latter.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Augur:")]), _vm._v(" A magician-priest of ancient Rome who predicted the future by the flight of birds.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Augury:")]), _vm._v(" In ancient Rome, divination by the flight of birds. The word is used generally for all kinds of divination, also for any omen or sign on which divination is or can be based.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aum:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("om.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Aura:")]), _vm._v(" In occult terminology, a psychic effluvium that emanates from human and animal bodies and inanimate objects. The aura is multi-colored and brilliant, or dull, according to the character or quality of the person or thing. It is composed of electro-vital and electro-mental magnetism; an envelope surrounding that of which it partakes—visible only to the psychic. To the seer, the aura of a person is an index to his hidden propensities.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Auric egg:")]), _vm._v(" In esoteric philosophy, especially in theosophical occultism, the source of the human "), _c('em', {
    staticClass: "i"
  }, [_vm._v("aura")]), _vm._v(" (q.v.) and the seat of the higher spiritual and mental faculties.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Austerities:")]), _vm._v(" Severe self-discipline of the body, even to self-infliction of cruel torture, for the welfare and purification of the soul or spirit.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Austromancy:")]), _vm._v(" Foretelling the future by using the winds as sources of divinatory data.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Automatic drawing:")]), _vm._v(" The production of drawing by a medium without control of his conscious self; also, the drawing so produced.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Automatic painting:")]), _vm._v(" The production of paintings by a medium without control of his conscious self; also, the painting so produced.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Automatic speech:")]), _vm._v(" The phenomenon of a medium’s speaking without control of his conscious self.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Automatic writing:")]), _vm._v(" The production of script by a medium without control of his conscious self; also, the script so produced.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Automatism:")]), _vm._v(" In mediumistic and parapsychological terminology, the collective term for automatic writing, automatic drawing (q.v.), and all other activities performed without the conscious awareness and will of the individual.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Avatar:")]), _vm._v(" A Sanskrit term, which in Hindu terminology is used properly in the meaning of “an incarnation of Vishnu.” Theosophists and other believers in occultism and esotericism use it in the general meaning of any "), _c('em', {
    staticClass: "i"
  }, [_vm._v("divine incarnation.")]), _vm._v(" The word is frequently used also to denote one spiritually highly developed through many incarnations on the material plane of existence. (This is the meaning of the term in Rosicrucianism, in particular.)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Avesta:")]), _vm._v(" The sacred book of the Zoroastrians. The original Avesta (also called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Zend")]), _vm._v(") was said to comprise all knowledge; most of it was destroyed by Alexander. A work of 21 volumes ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("nasks")]), _vm._v(") was prepared out of its remnants in the third century A.D., but only one volume ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Vendidad")]), _vm._v(") has survived complete.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Avidya:")]), _vm._v(" A Sanskrit term for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("ignorance.")]), _vm._v(" Unawareness of true reality.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Avyakta:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("unmanifested, undifferentiated;")]), _vm._v(" the uncaused cause of material or phenomenal existence.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Axis mundi:")]), _vm._v(" Latin for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("axis of the world.")]), _vm._v(" In occult and magical terminology, the point at which communication is made between heaven, earth and hell.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ayam atma brahma:")]), _vm._v(" Sanskrit for “"), _c('em', {
    staticClass: "i"
  }, [_vm._v("this self is")]), _vm._v(" brahman.” A famous quotation from the Upanishads, alluding to the central theme of the Upanishads—the identity of the human and divine or cosmic.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Azael:")]), _vm._v(" In Hebrew mysticism, one of the angels who rebelled against God.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Azazel:")]), _vm._v(" The mysterious creature dwelling in the desert to which the Hebrews of biblical times sent forth their "), _c('em', {
    staticClass: "i"
  }, [_vm._v("scapegoats")]), _vm._v(" (q.v.). In latter Hebrew mysticism, this name was used as that of one of the fallen angels.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef5c343e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/e9780806537009_c01.vue
// module id = 75
// module chunks = 0